<template>
    <div :class="classes">
        <!--    TODO: GN-15209: remove inline display: none style when adding custom branding -->
        <router-link style="display: none" :to="{ name: 'sponsorships' }">
            <img :src="GRIN_LOGO_BLACK" width="100px" alt="Grin logo" />
        </router-link>

        <g-settings-button @click="navigateToSettings" />
        <settings-drawer :visible="isSettingsDrawerVisible" @close="hideSettingsDrawer" />
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import { GRIN_LOGO_BLACK } from '../../../../app-v2/constants/cdn-assets';
    import SettingsDrawer from '../settings/SettingsDrawer.vue';
    import useToggle from '../../../composables/use-toggle';
    import { useContactStore } from '../../../../stores';
    import useEventTracking from '../../../composables/use-event-tracking';
    import useRouter from '../../../composables/use-router';
    import { EVENT_NAME_SETTINGS_AVATAR_CLICKED } from '../../../../app-v2/constants/analytics-events';

    export default {
        name: 'NavigationTopBar',
        components: {
            SettingsDrawer
        },
        setup(props, context) {
            const contact = useContactStore().data;
            const events = useEventTracking();
            const router = useRouter().get();
            const isMobile = window.matchMedia('(max-width: 480px)').matches;

            const settingsTrackEvent = () => {
                events.trackEvent(EVENT_NAME_SETTINGS_AVATAR_CLICKED, {
                    dl_contact_id: contact.id
                });
            };

            const {
                currentValue: isSettingsDrawerVisible,
                setTrue: showSettingsDrawer,
                setFalse: hideSettingsDrawer
            } = useToggle(false);

            function navigateToSettings() {
                settingsTrackEvent();
                if (isMobile) {
                    showSettingsDrawer();
                } else {
                    router.push({ name: 'edit.profile' });
                }
            }

            const classes = computed(() => {
                return {
                    'navigation-top-bar': true,
                    'hide-border': context.root.$route.name === 'edit.profile'
                };
            });

            return {
                GRIN_LOGO_BLACK,
                isSettingsDrawerVisible,
                hideSettingsDrawer,
                isMobile,
                navigateToSettings,
                classes
            };
        }
    };
</script>

<style lang="scss" scoped>
    .navigation-top-bar {
        display: flex;
        //TODO GN-15209: change flex-end back to space-between when adding back in logo on left side of nav bar
        justify-content: flex-end;
        align-items: center;
        padding: 0 15px;
        height: 56px;
        border-bottom: 1px solid #e5e8eb;
    }

    .hide-border {
        border: 0 none;
    }
</style>
